export const environment = {
  production: false,
  apiUrl: 'https://yr0rjfn9bj.execute-api.sa-east-1.amazonaws.com/prod',
  userPoolId: 'us-east-1_cuJKKjzpo',
  userPoolClientId: '7leqdvtad06d3getokokebti2c'
};